import { Button } from '@massilia/ui'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Check } from 'lucide-react'

export const Route = createFileRoute('/_blue_header/devis-envoye')({
  component: EstimateSentComponent,
})

export function EstimateSentComponent() {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center gap-6">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
        <Check className="h-8 w-8 text-green-600" />
      </div>
      <div className="flex max-w-md flex-col items-center gap-4 text-center">
        <div className="text-gray-light-900 text-2xl font-semibold">
          Notre équipe a bien reçu votre demande.
        </div>
        <div className="text-sm font-medium text-gray-900">
          Nos équipes vous répondront sous 72 heures maximum.
        </div>
        <Button
          className="mt-4 w-37.5 text-sm"
          onClick={() => navigate({ to: '/recherche' })}
          type="button"
        >
          Revenir sur le site
        </Button>
      </div>
    </div>
  )
}
